import { jsx as _jsx } from "react/jsx-runtime";
import { ContainerView } from './container_view';
import { TableView } from './table_view/table_view.component.v2';
/**
 *  Styles will be inlined since these components will be rendered for PDF generation
 */
export const ParticipantStatusesPreview = ({ productMessages, messages, sortIndex }) => {
    var _a, _b, _c, _d;
    if (!messages) {
        return null;
    }
    const columns = [
        {
            key: 'participant_number',
            label: (_a = productMessages === null || productMessages === void 0 ? void 0 : productMessages.participant_number) !== null && _a !== void 0 ? _a : 'Participant Number',
            render: (value) => (_jsx("span", { style: { color: 'rgb(95, 70, 207)', textDecoration: 'underline' }, children: value })),
        },
        { key: 'created', label: (_b = productMessages === null || productMessages === void 0 ? void 0 : productMessages.created) !== null && _b !== void 0 ? _b : 'Created' },
        { key: 'next_visit', label: (_c = productMessages === null || productMessages === void 0 ? void 0 : productMessages.next_visit) !== null && _c !== void 0 ? _c : 'Next visit (window)' },
        {
            key: 'status',
            label: (_d = productMessages === null || productMessages === void 0 ? void 0 : productMessages.status) !== null && _d !== void 0 ? _d : 'Status',
            render: (value) => (_jsx("span", { style: {
                    display: 'inline-block',
                    borderRadius: 6,
                    background: '#F3F4F6',
                    border: '1px solid #E5E7EB',
                    color: '#111827',
                    fontSize: 13,
                    fontWeight: 'bold',
                    padding: '2px 12px',
                    lineHeight: 1.5,
                    minWidth: 32,
                    textAlign: 'center',
                }, children: value })),
        },
    ];
    const data = Object.keys(messages)
        .sort((a, b) => { var _a, _b; return ((_a = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[a]) !== null && _a !== void 0 ? _a : 0) - ((_b = sortIndex === null || sortIndex === void 0 ? void 0 : sortIndex[b]) !== null && _b !== void 0 ? _b : 0); })
        .map((message, index) => ({
        participant_number: `P0000${index + 1}`,
        created: '-',
        next_visit: '-',
        status: messages[message],
    }));
    return [
        _jsx(ContainerView, { children: _jsx("div", { style: { padding: '2rem' }, children: _jsx(TableView, { data: data, columns: columns }) }) }, 'participant-statuses-root'),
    ];
};
//# sourceMappingURL=participant_statuses.preview.component.js.map